import { gql } from '@apollo/client';

export const GET_REMINDER_CONFIGS = gql`
  query GetReminderConfigs {
    tm {
      tenant {
        config {
          reminderConfigs {
            tenantReminderConfigId
            daysBefore
            reminderType
            customContent
            isEnabled
          }
        }
      }
    }
  }
`;